import { apiDlUrl } from '@/environment/environment';

export const apiConstants = {
  fetchGuide: 'mock-data/senser/guide.json',
  fetchTags: 'mock-data/tags.json',
  fetchArtefacts: 'mock-data/senser/artefacts.json',
  fetchArtefact: 'mock-data/senser/artefact.json',
  fetchArtifactUnit: 'mock-data/senser/artefactUnit.json',
  dstat_mock: 'mock-data/senser/districtstat.json',
  sstat_mock: 'mock-data/senser/statestat.json',
  // sdt_mock: 'mock-data/senser/appstoredemand_delhi_jk.json',
  // sdf_mock: 'mock-data/senser/appstoreskudemand_delhi_jk.json',
  // sdf: 'mock-data/senser/appstoreskudemand_delhi_jk.json',
  // scdf_mock: 'mock-data/senser/appstoreskudemand_delhi_jk.json',
  sdt_mock: 'mock-data/senser/demfor_overall.json',
  sdf_mock: 'mock-data/senser/demfor_cat.json',
  sdf: 'mock-data/senser/demfor_cat.json',
  scdf_mock: 'mock-data/senser/demfor_cat.json',
};
